export default __webpack_public_path__ + "media/fonts/foundation-icons/foundation-icons-e765a16d11a4a296dc00308feacf7959.woff";